/*
 * Hover image carousel for the collection product grid.
 *
 * Load-speed contract: the Liquid renders ONLY the featured image. Every other
 * image for a card exists in the HTML purely as a JSON payload of CDN urls
 * (no width parameter, so it is short). Nothing is fetched until the pointer
 * first enters a card, at which point the <img> elements are created and the
 * browser requests them. A collection page that is never hovered costs exactly
 * one image per product -- one fewer than before, since this replaces the
 * always-rendered second "hover" image.
 *
 * Arrows only exist on hover-capable devices (the CSS hides them otherwise),
 * so touch users keep the single static image and load nothing extra.
 */
(function () {
  'use strict';

  // The collection grid and the homepage "New Additions" grid.
  var grids = document.querySelectorAll('#main-collection-product-grid, .featured-products__list, .product-recommendations__list');
  if (!grids.length) return;

  var SIZES =
    '(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)';

  function withWidth(url, w) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  // Creates the extra <img> elements for a card. Runs at most once per card.
  function build(card) {
    if (card.dataset.carouselBuilt) return true;

    var holder = card.querySelector('.card-carousel');
    var payload = card.querySelector('.js-card-media');
    if (!holder || !payload) return false;

    var items;
    try {
      items = JSON.parse(payload.textContent);
    } catch (e) {
      return false;
    }
    if (!items || !items.length) return false;

    var frag = document.createDocumentFragment();
    items.forEach(function (item) {
      var img = document.createElement('img');
      img.src = withWidth(item.u, 533);
      img.srcset = withWidth(item.u, 533) + ' 533w, ' + withWidth(item.u, 1066) + ' 1066w';
      img.sizes = SIZES;
      img.alt = item.a || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.className = 'motion-reduce card-carousel__slide';
      frag.appendChild(img);
    });

    // Insert before the arrows so the images stay underneath them.
    holder.insertBefore(frag, holder.querySelector('.card-carousel__arrow'));

    card.dataset.carouselBuilt = '1';
    card.dataset.carouselIndex = '0';

    // `is-ready` hands opacity control to the is-active class.
    var first = holder.querySelector('.media--first');
    if (first) first.classList.add('is-active');
    holder.classList.add('is-ready');

    return true;
  }

  function slidesOf(card) {
    return card.querySelectorAll('.card-carousel > .media--first, .card-carousel > .card-carousel__slide');
  }

  function show(card, index) {
    var slides = slidesOf(card);
    if (!slides.length) return;

    index = ((index % slides.length) + slides.length) % slides.length;
    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.toggle('is-active', i === index);
    }
    card.dataset.carouselIndex = String(index);
  }

  // mouseover bubbles (mouseenter does not), so one listener covers every card.
  grids.forEach(function (grid) {
    grid.addEventListener('mouseover', function (event) {
      var card = event.target.closest('.card-wrapper');
      if (card) build(card);
    });

    // Back to the featured image once the pointer leaves the card.
    grid.addEventListener('mouseout', function (event) {
      var card = event.target.closest('.card-wrapper');
      if (!card || !card.dataset.carouselBuilt) return;
      if (event.relatedTarget && card.contains(event.relatedTarget)) return;
      show(card, 0);
    });

    // The whole card is covered by an overlay <a>, so stop the click reaching it.
    grid.addEventListener('click', function (event) {
      var arrow = event.target.closest('.card-carousel__arrow');
      if (!arrow) return;

      event.preventDefault();
      event.stopPropagation();

      var card = arrow.closest('.card-wrapper');
      if (!card || !build(card)) return;

      var step = arrow.classList.contains('card-carousel__arrow--next') ? 1 : -1;
      show(card, parseInt(card.dataset.carouselIndex || '0', 10) + step);
    });
  });
})();
